import { render, staticRenderFns } from "./BatchLaborCost.vue?vue&type=template&id=5edf57c4&scoped=true"
import script from "./BatchLaborCost.vue?vue&type=script&lang=ts"
export * from "./BatchLaborCost.vue?vue&type=script&lang=ts"
import style0 from "./BatchLaborCost.vue?vue&type=style&index=0&id=5edf57c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf57c4",
  null
  
)

export default component.exports